import { render, staticRenderFns } from "./UseCaseCard.vue?vue&type=template&id=fa1b9a86&"
import script from "./UseCaseCard.vue?vue&type=script&lang=js&"
export * from "./UseCaseCard.vue?vue&type=script&lang=js&"
import style0 from "./UseCaseCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports